import comp from "./ForwardMessageContainer.js";
export default comp;
